import { render, staticRenderFns } from "./ocrSign.vue?vue&type=template&id=782039c5&scoped=true&"
import script from "./ocrSign.vue?vue&type=script&lang=js&"
export * from "./ocrSign.vue?vue&type=script&lang=js&"
import style0 from "./ocrSign.vue?vue&type=style&index=0&id=782039c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782039c5",
  null
  
)

export default component.exports